import { render, staticRenderFns } from "./BizDynamicLink.vue?vue&type=template&id=d94aae3a&"
import script from "./BizDynamicLink.vue?vue&type=script&lang=js&"
export * from "./BizDynamicLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports